var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoldingHandDinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,14h-1c0-5.506-4.07-10.066-9.357-10.863,.224-.323,.357-.714,.357-1.137,0-1.105-.895-2-2-2s-2,.895-2,2c0,.423,.133,.814,.357,1.137C5.07,3.934,1,8.494,1,14H0v2H3.01c-.656,.738-1.137,1.646-1.37,2.67L.429,24H2.48l1.111-4.887c.417-1.833,2.021-3.113,3.9-3.113h6.008c.63,0,1.142,.513,1.142,1.143,0,.564-.421,1.051-.981,1.13l-5.161,.737,.283,1.98,5.16-.737c.625-.089,1.181-.369,1.629-.767l.013,.015,3.729-3.247c.402-.362,1.079-.32,1.426,.1,.362,.416,.321,1.052-.091,1.418h0s0,0-.001,0l-7.002,6.228h3.009l5.321-4.732h0s0,0,0,0h0s0,0,0,0c.941-.836,1.226-2.143,.826-3.266h1.197v-2Zm-21,0c0-4.963,4.038-9,9-9s9,4.037,9,9H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingHandDinner);
export default __webpack_public_path__ + "static/media/holding-hand-dinner.26223dcc997d62cd7fcf036a712ce9d3.svg";
export { ForwardRef as ReactComponent };